var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMute = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 17,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9.722 2.742a.667.667 0 0 0-1.093-.512l-3.63 3.024c-.12.1-.27.155-.426.155H1.055a.667.667 0 0 0-.666.667v5.333c0 .368.298.667.666.667h3.518c.156 0 .307.054.426.154l3.63 3.024a.667.667 0 0 0 1.093-.512z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M10.94 5.913c.26-.26.683-.26.943 0a4 4 0 0 1 1.172 2.829 4 4 0 0 1-1.172 2.828.667.667 0 1 1-.943-.943 2.66 2.66 0 0 0 .781-1.885c0-.737-.297-1.403-.78-1.886a.667.667 0 0 1 0-.943",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M12.827 4.028c.26-.26.682-.26.943 0a6.65 6.65 0 0 1 1.952 4.714c0 1.84-.747 3.508-1.952 4.714a.667.667 0 1 1-.943-.943 5.31 5.31 0 0 0 1.562-3.77 5.31 5.31 0 0 0-1.562-3.772.667.667 0 0 1 0-.943",
  clipRule: "evenodd"
})));
export { SvgMute as ReactComponent };
export default "/_next/static/images/mute.svg";